module.exports = __webpack_public_path__ + "img/uok.c7b1ef69.png";